import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import CollapsibleBox from 'components/global/CollapsibleBox';
import getServiceDisplayNames from './serviceDisplayNames';

const KnowledgeLink = styled('a')({
  textDecoration: 'underline',
  fontWeight: 'bold',
  color: '#0073e6',
});

const StyledServiceCard = styled(Card)({
  width: '100%',
  minHeight: '50px',
  background: '#FAFAFA',
  boxShadow: 'none',
  fontWeight: '600',
  fontSize: '15px',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '30px',
  marginBottom: '10px',
  borderRadius: '10px',
});

const ServiceCardTitle = styled('span')({
  margin: '0px',
  color: '#303333',
  fontSize: '15px',
  fontWeight: '600',
});

const ServiceCard = ({ serviceName }) => (
  <StyledServiceCard>
    <ServiceCardTitle>{serviceName}</ServiceCardTitle>
  </StyledServiceCard>
);

const ServiceGroup = ({ categoryName, services, intl }) => {
  const serviceDisplayNames = getServiceDisplayNames(intl);

  const hasVisibleServices = Object.values(services).some(value => value);

  if (!hasVisibleServices) {
    return null;
  }

  return (
    <div>
      <CollapsibleBox title={categoryName}>
        <div style={{ marginBottom: '30px' }}>
          <p>
            <FormattedMessage
              defaultMessage="For more information on any of the available services, please consult our {link}."
              values={{
                link: (
                  <KnowledgeLink
                    href="https://greenshieldhealthpractitioner.zendesk.com/hc/en-ca/articles/36489624233108-Health-services-available-to-GreenShield-clients"
                    target="_blank"
                  >
                    <FormattedMessage defaultMessage="Knowledge Base" />
                  </KnowledgeLink>
                ),
              }}
            />
          </p>
        </div>
        {Object.entries(services).map(([key, value]) => {
          if (value) {
            return (
              <ServiceCard
                key={key}
                serviceName={serviceDisplayNames[key] || key}
              />
            );
          }
          return null;
        })}
      </CollapsibleBox>
    </div>
  );
};

ServiceCard.propTypes = {
  serviceName: PropTypes.node.isRequired,
};

ServiceGroup.propTypes = {
  categoryName: PropTypes.string.isRequired,
  services: PropTypes.objectOf(PropTypes.bool).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

injectIntl(ServiceCard);
export default injectIntl(ServiceGroup);
